import { Image } from '@vizit/atoms';
import { ImageLegend, type ImageLegendVariant } from '@vizit/molecules';
interface ArtifactViewerProps {
  /**
   * The name of the asset that will be in the alt text of the image.
   */
  assetName?: string;
  /**
   * The source of the image artifact.
   */
  src: string | null;
  /**
   * Whether the image is loading.
   */
  isLoading: boolean;
  /**
   * Whether the image is broken.
   */
  isBroken: boolean;
  /**
   * The image legend variant.
   */
  imageLegendVariant: ImageLegendVariant;
  /**
   * Custom label for the image legend (overrides default label for the variant).
   */
  legendLabel?: string;
}

const ArtifactViewer = (props: ArtifactViewerProps) => {
  const { assetName = 'Asset', src, isLoading = true, isBroken = false, imageLegendVariant, legendLabel } = props;

  return (
    <div className="h-full w-full max-h-[calc(100vh-153px)] bg-dot-grid py-12 flex flex-col items-center justify-start gap-12 max-lg:border-b max-lg:border-secondary max-lg:gap-12">
      <div className="flex-shrink">
        <ImageLegend variant={imageLegendVariant} leftLabel={legendLabel} />
      </div>
      <div className="grid grid-cols-5 justify-center items-start w-full h-full max-w-screen-xl max-4xl:max-w-screen-lg">
        <div className="col-start-2 col-span-3 w-full h-auto object-contain">
          <Image isBroken={isBroken} src={src} isAnalyzing={isLoading} name={assetName ?? 'Image Asset'} />
        </div>
      </div>
    </div>
  );
};

export { ArtifactViewer };
export type { ArtifactViewerProps };
